/**
 * Ryan O'Dowd
 * 2026-03-08
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      minWidth: 500,
    },
  };
};

export default getStyles;
